import { PushClient } from '../api/util/PushClient';
import { SiteSummary } from '../models';
import axios from 'axios';
import { api as apiConfig } from 'src/config';
import { ApiError } from '../api/util/ApiError';

export interface PortfolioQuery {
  endUserName?: string;
  endUserAddress?: string;
  installerCompanyName?: string;
  equipmentType?: string;
  equipmentQuantityOperator?: string;
  equipmentQuantity?: string;
  equipmentSerialNumber?: string[];
  equipmentFirmwareVersion?: string;
  equipmentFirmwareVersionOperator?: string;
  onlineStatus?: string;
  signalStrength?: string;
  sortBy?: string;
  sortAscending?: boolean;
  pageNumber: number;
  pageSize?: number;
  nameAddressFilter?: string;
}

export interface PortfolioResponse {
  sites: SiteSummary[];
  totalMatchingSites: number;
  pageNumber: number;
}
export interface PortfolioOptions {
  installers: string[];
  equipmentTypes: string[];
  equipmentFirmwareVersions: { Model: string; FirmwareVersion: string }[];
}

export class PortfolioApi extends PushClient {
  static baseUrl = '/Snapshot/portfolio';

  public async querySiteSummaries(query: PortfolioQuery): Promise<PortfolioResponse> {
    return this.singleMessagePostRequest(PortfolioApi.baseUrl, query);
  }

  public async fetchPortfolioOptions(): Promise<PortfolioOptions> {
    return this.singleMessageGetRequest(`${PortfolioApi.baseUrl}/filterOptions`);
  }

  public async downloadCSV(query: PortfolioQuery): Promise<Blob> {
    const axiosInstance = this.client.createClientForVersion('2.0');
    const url = `/portfolio/download`;

    try {
      const response = await axiosInstance.post(url, query, {
        responseType: 'blob',
        timeout: apiConfig.httpTimeoutDefault,
      });

      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        throw new ApiError(error);
      } else {
        throw new ApiError(undefined, (error as Error).message);
      }
    }
  }
}
